import SizeHelper from "helpers/form-field-size-helper";
import FitRecHelpers from "helpers/fit-rec-helpers";
import MembershipHelpers from "helpers/membership-helpers";

// creating a buynow specific function set - will modify existing function
export function buyNowGridAvailability(product = {}) {
  function getDefaultSizeSelection(userData = {}, workingFilters) {
    let { defaultSizeSelection } = SizeHelper.constants;
    const { fitRates } = product;
    const primarySize = userData?.userProfile?.profiles?.primarySize;

    // If a fit rate of over 75% exists for product then user is auto selected into that size - AS 4/27/2022
    if (fitRates?.length > 0) {
      const recommendedAvailableSizes = FitRecHelpers.allRecommended(fitRates, primarySize).find(fitRate => {
        return hasSkuCount(fitRate.size);
      });

      if (recommendedAvailableSizes) {
        return {
          size: recommendedAvailableSizes.size,
          sku: product.skus.find(sku => sku.size === recommendedAvailableSizes.size)?.id,
        };
      }
    }

    // If sizeless accessory, default to empty value input === "", save sku for adding and return out.
    if (SizeHelper.isOneSizeFitsAll(product)) {
      // props.product.skus always returns a list. In the one size fits all case, it's a list of 1.
      return {
        size: defaultSizeSelection,
        sku: product.skus?.[0]?.id,
      };
    }

    if (SizeHelper.hasWorkingSizeFilters(workingFilters)) {
      defaultSizeSelection = filteredSizeWithACount(workingFilters);
    }

    return {
      size: defaultSizeSelection,
      sku: product.skus?.find(sku => sku.size === defaultSizeSelection)?.id,
    };
  }

  function filteredSizeWithACount(workingFilters) {
    let filteredSizes = [];

    if (!SizeHelper.isUSAStandardSizes(product)) {
      filteredSizes = regionalSizeFilters(workingFilters);
    } else {
      filteredSizes = workingFilters.canonicalSizes;
    }

    return filteredSizes
      .filter(Boolean)
      .reduce((a, b) => a.concat(b), [])
      .find(size => hasSkuCount(size));
  }

  function hasSkuCount(selectedSize) {
    const allSkusCounts = sizeToAvailabilityCountMap();
    return Boolean(allSkusCounts?.[selectedSize]?.count);
  }

  function sizeToAvailabilityCountMap() {
    // returns an object: { S: { count: 3 }, M: {count: 4}, L: {}... }
    return product?.skus?.reduce((memo, sku) => {
      const membershipAvailability = MembershipHelpers.getAvailabilityForBuyGrid(sku);
      memo[sku.size] = membershipAvailability?.count ? { count: membershipAvailability.count } : {};
      return memo;
    }, {});
  }

  function sizeWithDefaultLength(listOfSizes) {
    // Due to some "interesting" size scales e.g.
    // ["00P", "00R", "00L", "00XL", "0P", "0R", "0L", "0XL"], ["XXSP", "XXSR", "XXSL", "XXSXL", "XSP", "XSR", "XSL", "XSXL"]
    // We can match for the defaultLength "R" but also check for the count to preselect the correct one.
    return listOfSizes?.find(size => size.match(SizeHelper.constants.defaultLength) && hasSkuCount(size));
  }

  function regionalSizeFilters(workingFilters) {
    return workingFilters?.canonicalSizes.map(size => {
      if (SizeHelper.hasLengths(product)) {
        return sizeWithDefaultLength(SizeHelper.regionalSizeList(product, size));
      } else {
        return SizeHelper.regionalSizeList(product, size);
      }
    });
  }
  return {
    getDefaultSizeSelection: getDefaultSizeSelection,
    sizeToAvailabilityCountMap: sizeToAvailabilityCountMap,
    hasSkuCount: hasSkuCount,
    filteredSizeWithACount: filteredSizeWithACount,
    sizeWithDefaultLength: sizeWithDefaultLength,
    regionalSizeFilters: regionalSizeFilters,
  };
}
